@if(template(); as template){
		@for(control of formArray().controls; track $index; let index = $index, count = $count, last	= $last){ 
			<section class="dynamic-field">
			<div class="field">
					<ng-container *ngTemplateOutlet="template; context: { index: index }" />
			</div>
				@if(index >= minItems()){ 
					<button mat-icon-button type="button" (click)="removeItem(index)" [disabled]="formArray().disabled || control.disabled">
						<ogs-m3-icon	icon="minus-square" />
					</button>
				}
				
				@if (canAdd() && last){
					<button mat-icon-button type="button" (click)="addItem()" [disabled]="formArray().disabled || control.disabled">
						<ogs-m3-icon	icon="plus-square" />
					</button>
		 	}
			 </section>
	 } 
}
